module.exports = __webpack_public_path__ + "assets/img/page-header.0a103710.jpg";